import { render } from "./TripsPanel.vue?vue&type=template&id=20b0bb86"
import script from "./TripsPanel.vue?vue&type=script&lang=js"
export * from "./TripsPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__